/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DismissDialog.vue?vue&type=template&id=f26320be"
import script from "./DismissDialog.vue?vue&type=script&lang=js"
export * from "./DismissDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f26320be')) {
      api.createRecord('f26320be', component.options)
    } else {
      api.reload('f26320be', component.options)
    }
    module.hot.accept("./DismissDialog.vue?vue&type=template&id=f26320be", function () {
      api.rerender('f26320be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/DismissDialog.vue"
export default component.exports